import dayjs from 'dayjs'

import { useAppContext } from 'context/AppContext'

const FIXED_DATE = '2022-10-05T12:00:00.000+02:00'

export const useDate = () => {
  const { isCypressTakingSnapshots } = useAppContext()

  const getDate = date => (isCypressTakingSnapshots ? dayjs(FIXED_DATE) : dayjs(date))

  return { getDate }
}
